import { useEffect, useState } from "react";

// import styles of this component
import styles from "./App.module.css"

// import other components to use
import Header from './Components/Header/Header';
import Youtube from './Components/Youtube/Youtube';
import MasonryLayout from './Components/MasonryLayout/MasonryLayout';
import ContainerCard from './Components/ContainerCard/ContainerCard';
import Dropdown from './Components/Elements/Dropdown/Dropdown';

// import json files 
import images from "./Jsons/Images.json"
import Instagram from "./Components/Instagram/Instagram";
import MAP from "./Components/Map/Map";
import { Helmet } from "react-helmet";

// App component
const App = () => {
  // dropdown items
  const ddItems = [
    {
      id: 1,
      title: "Featured",
      active: true,
      folder: false
    },
    {
      id: 2,
      title: "Events",
      active: false,
      folder: 'events'
    },
    {
      id: 3,
      title: "Club",
      active: false,
      folder: 'club'
    },
    {
      id: 4,
      title: "Studio & Lifestyle",
      active: false,
      folder: 'lifestyle'
    },
    {
      id: 5,
      title: "Product",
      active: false,
      folder: 'product'
    },
    {
      id: 6,
      title: "Automotive",
      active: false,
      folder: 'automotive'
    },
  ]

  const [categoryImage, setCategoryImage] = useState(images.categories.featured)
  const [currentChannelId, setCurrentChannelId] = useState('UCt1jBjgjUpdQ4HB57R7BTHA');
  const [videos, setVideos] = useState([]);

  const baseUrl = 'https://wrapapi.com/use/horoscopulazi/alinzvincacom/youtube/0.0.1?wrapAPIKey=Wf16jTpl2Y1kNiGOfraoEQwbgc6mMM1d';

  useEffect(() => {
    (async () => {
      if (currentChannelId) {
        try {
          const data = await fetch(`${baseUrl}`).then(response => response.json());
          const regex = /href="([^"]+)"/;
          const str = data.data["first video"];
          const match = regex.exec(str);

          if (match) {
            setVideos(match[1]);
          } else {
            console.log('No match found');
          }
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, []);

  const takeDdTitle = (ddTitle) => {
    setCategoryImage(() => {
      const categoryChoose = ddTitle.folder

      // return categoryChoose ? imageList : [...images.categories['featured']]

      switch (ddTitle.id) {
        case 1: {
          return [...images.categories['featured']];
          break;
        }
        case 2: {
          const imagesFolder = require.context('../public/img/events', true);
          const imageList = imagesFolder.keys().map(image => imagesFolder(image)).reverse();

          return imageList;
          break;
        }
        case 3: {
          const imagesFolder = require.context('../public/img/club', true);
          const imageList = imagesFolder.keys().map(image => imagesFolder(image)).reverse();

          return imageList;
          break;
        }
        case 4: {
          const imagesFolder = require.context('../public/img/studio', true);
          const imageList = imagesFolder.keys().map(image => imagesFolder(image)).reverse();

          return imageList;
          break;
        }
        case 5: {
          const imagesFolder = require.context('../public/img/product/compressed/pictures', true);
          const imageList = imagesFolder.keys().map(image => imagesFolder(image)).reverse();

          return imageList;
          break;
        }
        case 6: {
          const imagesFolder = require.context('../public/img/automotive/compressed/pictures', true);
          const imageList = imagesFolder.keys().map(image => imagesFolder(image)).reverse();

          return imageList;
          break;
        }
        default: {
          return [...images.categories['featured']];
          break;
        }
      }
    })
  }

  return (
    <>
      <Helmet>
        <title>Alin Zvinca - My Experience</title>
        <meta name="description" content="I'm so glad to meet you! The search has ended here. Fotograf, Videograf Iasi Studio, Editorial, Fashion, Craciun, Nunta, Botez, Majorat, Corporate." />
      </Helmet>
      <div className="containerBody">
        <Header />
        <MAP />
        <Instagram />
        {videos && videos[0] && <Youtube video={videos} />}
        <div className="flex justify-content-center" style={{ marginTop: "50px", padding: '50px' }}>
          <ContainerCard>
            <div className={`${styles["gallery-setting"]} flex justify-content-between align-items-center`}>
              <div className={styles["gallery-titles"]}><h1 id="bangers">The shots that matter</h1></div>
              <div className={styles["break"]}></div>
              <div className={styles["tools"]}>
                <Dropdown title="Filter" items={ddItems} liftingDdTextUp={takeDdTitle} />
                <a href="https://wa.link/298mdb" target="_blank" className={styles["btn-mix-noborder"]} data-text="Ai alte idei?">Ai alte idei?</a>
              </div>
            </div>
            <MasonryLayout images={categoryImage} />
          </ContainerCard>
        </div>
      </div>
    </>
  )
}

export default App